import { Card, OutlineButton, PopupDialogbox, Accordion, AttachmentCommonUpload } from '../../../../../CommonComponents';
import './LeadrOrder.scss'
import Moment from 'moment';
import permissions, { ACCESS_DENIED, isAuthorized } from 'client/utils/Permissions';
import RequestDetail from '../../RequestDetail';
import AttachmentLinkContainer from 'client/Components/OrderManagement/ApprovalOrder/LeadrOrder/ItemDetail/AttachmentLink/AttachmentLink-Container';
import { CONSTANTS } from 'client/utils/constants';
import React from 'react';

interface IProps {
    transferOrderByIdData?: any,
    handleClickOrder?: any,
    cancelOrderReq?: any,
    Popupcontent?: any,
    hideDialog?: any,
    userDetails?: any;
    createdDateval?: any;
    createdRequestTypeVal?: any;
    popupPrimarybtnOnclick?: any;
    ordertype?: any;
    assetOrderDetailAttachments?: any;
    setDocumentList?: any;
    documentList?: any;
    setAttachmentError?: any;
    attachmentError?: any;
    onUploadClick?: any;
    onRemoveAttachment?: any;
    getUserRoles: any;
}
const LeaderOrder = ({
    createdDateval,
    transferOrderByIdData,
    handleClickOrder,
    cancelOrderReq,
    Popupcontent,
    hideDialog,
    userDetails,
    createdRequestTypeVal,
    popupPrimarybtnOnclick,
    ordertype,
    assetOrderDetailAttachments,
    setDocumentList,
    documentList,
    setAttachmentError,
    attachmentError,
    onUploadClick,
    onRemoveAttachment,
    getUserRoles
}: IProps) => {
    const cancelOrdersubtext = (
        <>
            <p>Are you sure you want to cancel the Order</p>
            <p>
                <b>LEADR Order # : </b>{transferOrderByIdData?.orderId}
            </p>
        </>
    );

    const requestDetails = transferOrderByIdData?.transferDisposeReactivationDetails?.map((detailsByIdItem: any) => detailsByIdItem)

    const getIsAttachmentEditable = () => {
        const isEditable = (isAuthorized(permissions.CreateUpdateTransfers) && transferOrderByIdData?.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase()) 
        const isBOSRequired = (transferOrderByIdData?.orderRequestType === CONSTANTS.DISPOSITION && transferOrderByIdData?.bosAttachment?.attachmentUrl?.length > 0) ? true : false;
        return isEditable && isBOSRequired;
    }

    const ExpandedItems = [
        {
            headerText: (
                <div className='LeaderOrderHeader'>
                    <div className="leadrTitle leadrOrder">LEADR ORDER# - {transferOrderByIdData?.orderId}</div>
                    <div className="leadrHead">
                        <div className="orderRequestType">
                            <p className="label">Request Type</p>
                            <p>{ordertype === CONSTANTS.AFEREQUEST ? CONSTANTS.AFEREQUEST : createdRequestTypeVal()}</p>
                        </div>
                        <div>
                            {ordertype === CONSTANTS.AFEREQUEST ? (
                                <>
                                    <p className="label">AFE Type</p>
                                    <p>{transferOrderByIdData?.afeDetail?.afeType || '-'}</p>
                                </>
                            ) : (
                                <div>
                                    <p className="label">FRS Order #</p>
                                    <p>{transferOrderByIdData?.frsOrderNumber || '-'}</p>
                                </div>
                            )}
                        </div>
                        <div className="createdDate">
                            <p className="label">Created Date</p>
                            <p>{createdDateval()}</p>
                        </div>
                        <div className="updatedDate">
                            <p className="label">Updated Date</p>
                            <p>{transferOrderByIdData?.updatedDate ? Moment(transferOrderByIdData?.updatedDate).format('MM/DD/YYYY') : ''}</p>
                        </div>
                    </div>
                </div>
            ),
            content: <>
                <div className='p-3 pt-2 request-details-container'>
                    <div className="blueLabel pull-left">Request Details</div>
                    <div className='pull-right mb-3 right-side-section mt-2'>
                        {getIsAttachmentEditable() ?
                        <>
                            <a href={transferOrderByIdData?.bosAttachment?.attachmentUrl} target='_blank' className='bos-anchor-link'>Bill Of Sale(BOS)</a>  
                            <AttachmentCommonUpload
                                link={true}
                                list={documentList}
                                setList={setDocumentList}
                                multiple={true}
                                uploadBtnClick={onUploadClick}
                                error={attachmentError}
                                maxSize={5}
                                onRemove={(index: any) => onRemoveAttachment(index)}
                                uploadedList={assetOrderDetailAttachments}
                                tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                                setError={setAttachmentError}
                                iAttachmentEditable={getIsAttachmentEditable()}
                                isDownloadable={false}
                                disabled={!isAuthorized(permissions.CreateUpdateTransfers) || transferOrderByIdData?.orderStatus == CONSTANTS.ORDER_STATUS.REJECTED || transferOrderByIdData?.orderStatus == CONSTANTS.ORDER_STATUS.COMPLETED || transferOrderByIdData?.orderStatus == CONSTANTS.ORDER_STATUS.CANCELLED}
                                isChangesBeingTracked={false}
                             data-attribute="LeadrOrder_Default_AttachmentCommonUpload" />
                        </> : 
                        <AttachmentLinkContainer
                            item={transferOrderByIdData}
                            itemLevel={"Order"}
                        />}
                    </div>
                    <RequestDetail transferOrderByIdData = {transferOrderByIdData} detailsByIdItem={requestDetails?.pop()} />
                </div>
            </>,
            uuid: "Accordion1",
        }
    ];
    return <div className="LeaderOrderContainer customermyorder">
        <Card data-attribute="LeadrOrder_Default_Card">
            <Accordion
                Items={ExpandedItems}
                preExpanded={["Accordion1"]}
                className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
             data-attribute="LeadrOrder_Default_Accordion" />
            <div className='pull-right'>
                {
                    transferOrderByIdData?.orderStatus === "Returned to Requestor"
                        || transferOrderByIdData?.orderStatus === "Returned"
                        || transferOrderByIdData?.orderStatus === "Pending"
                        || transferOrderByIdData?.orderStatus === "Pending Approval"
                        || transferOrderByIdData?.orderStatus === "Saved"
                        ? <>
                            {((isAuthorized(permissions.CreateUpdateTransfers) || isAuthorized(permissions.ViewTransfers)) && transferOrderByIdData?.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase())
                                ? <OutlineButton
                                    disabled={(!isAuthorized(permissions.CreateUpdateTransfers) && !isAuthorized(permissions.ViewTransfers)) || transferOrderByIdData?.createdBy?.toLowerCase() !== userDetails?.emailId.toLowerCase()}
                                    text='Edit' className='pull-right me-0'
                                    onClick={() => handleClickOrder(transferOrderByIdData)}
                                    title={(isAuthorized(permissions.CreateUpdateTransfers) || isAuthorized(permissions.ViewTransfers)) && transferOrderByIdData.createdBy.toLowerCase() === userDetails?.emailId.toLowerCase() ? "Edit Order" : ACCESS_DENIED}
                                 data-attribute="LeadrOrder_Default_Button" />
                                : null}
                            {((((isAuthorized(permissions.DeleteTransfers) || isAuthorized(permissions.ViewTransfers)) && transferOrderByIdData.createdBy?.toLowerCase() === userDetails?.emailId?.toLowerCase() && transferOrderByIdData?.orderStatus !== "Saved")) || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) ?
                                <OutlineButton
                                    disabled={(!(isAuthorized(permissions.DeleteTransfers) || !isAuthorized(permissions.ViewTransfers) || transferOrderByIdData?.createdBy.toLowerCase() !== userDetails?.emailId.toLowerCase())) && !getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)}
                                    text='Cancel Order'
                                    className='pull-right'
                                    onClick={() => cancelOrderReq(cancelOrdersubtext)}
                                    title={((isAuthorized(permissions.DeleteTransfers) || isAuthorized(permissions.ViewTransfers)) && transferOrderByIdData.createdBy.toLowerCase() === userDetails?.emailId.toLowerCase()) || getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN) ? "Cancel Order" : ACCESS_DENIED}
                                 data-attribute="LeadrOrder_Default_Button_2" />
                                : null}


                        </>
                        : null
                }
            </div>
        </Card>
        {Popupcontent.isDialogVisible ? <PopupDialogbox
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={hideDialog}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={Popupcontent.popupOutlinebtnOnclick}
            popupPrimarybtnOnclick={(
                item: any,
                actionby: string,
                value: any
            ) => {
                popupPrimarybtnOnclick(
                    item,
                    actionby,
                    value
                );
            }}
         data-attribute="LeadrOrder_Default_PopupDilalogBox" /> : ""}
    </div>
}

export default LeaderOrder;
